export default __webpack_public_path__ + "static/media/limit_50.390452ff.svg";